/**
 * Calendar-day arithmetic on local dates. A day is a calendar date, never
 * "midnight plus 24 hours": on a clock-change day (25 or 23 hours long) the
 * millisecond step lands on the same date twice or skips one.
 */

/** The local midnight `days` calendar days after `date` (negative goes back). */
export const addCalendarDays = (date: Date, days: number): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);

/** `count` consecutive calendar days starting at `start`'s date, each at local midnight. */
export const calendarDaysFrom = (start: Date, count: number): Date[] =>
  Array.from({ length: count }, (_, i) => addCalendarDays(start, i));

/** A local date as its "YYYY-MM-DD" key. */
export const toLocalDateKey = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
